import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedTestrun: null,
};

const testRunSlice = createSlice({
  name: 'testrun',
  initialState,
  reducers: {
    setSelectedTestrun: (state, action) => {
      state.selectedTestrun = action.payload;
    },
    clearSelectedTestrun: (state) => {
      state.selectedTestrun = null;
    }
  },
});

export const {
  setSelectedTestrun,
  clearSelectedTestrun
} = testRunSlice.actions;

export default testRunSlice.reducer;
